<template>
    <div class="na-form">
        <div v-if="topicMemberStateDetail" class="left">
            <DxTabPanel>
                <DxItem title="Basisdaten">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">ID:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='topicMemberStateDetail.TmsId' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Name:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='topicMemberStateDetail.TmsName' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Erstellt am:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='topicMemberStateDetail.TmsCreatedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Erstellt von:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='topicMemberStateDetail.TmsCreatedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Geändert am:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='topicMemberStateDetail.TmsChangedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">Geändert von:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='topicMemberStateDetail.TmsChangedBy' :readOnly="true" />
                            </div>
                        </div>
                    </div>
                </DxItem>
                <DxItem title="Berechtigungen">
                    <DxDataGrid id="tsAccessList"
                                :data-source="accessListForTopicMemberState"
                                key-expr="TmrId"
                                :remote-operations="false"
                                :allow-column-reordering="true"
                                :row-alternation-enabled="true"
                                @exporting="onExporting"
                                :show-borders="true">
                        <DxColumn data-field="TmrId" caption="Rolle" data-type="string" :allowEditing="false" :width="120" :visible="false" />
                        <DxColumn data-field="TmrName" caption="Rolle" data-type="string" />
                        <DxColumn caption="Berechtigungen">
                            <DxColumn caption="Workflow" data-type="string">
                                <DxColumn caption="Sichtbar in Auswahlmenü" data-field="CanView" data-type="boolean"></DxColumn>
                                <DxColumn caption="Kann Status wechseln" data-field="CanChangeStatus" data-type="boolean"></DxColumn>
                            </DxColumn>
                            <DxColumn caption="Topic">
                                <DxColumn data-field="CanRead" caption="Lesen" data-type="boolean" />
                                <DxColumn data-field="CanUpdate" caption="Aktualisieren" data-type="boolean" />
                                <DxColumn data-field="CanDelete" caption="Löschen" data-type="boolean" />
                            </DxColumn>
                        </DxColumn>
                        <DxLoadPanel :enabled="true" />
                        <DxScrolling mode="virtual" />
                        <DxColumnChooser :enabled="true" />
                        <DxColumnFixing :enabled="true" />
                        <DxFilterRow :visible="true" />
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   select-text-on-edit-start="true"
                                   start-edit-action="click"
                                   mode="cell" />
                        <DxHeaderFilter :visible="true" />
                        <DxSearchPanel :visible="true"
                                       :width="240"
                                       placeholder="Search..." />
                        <DxExport :enabled="true"
                                  :allow-export-selected-data="true" />
                        <template #headerTemplate="{ data }">
                            <div class="tsHeaderCell">{{data.column.caption}}</div>
                        </template>
                        <template #cellTemplate="{ data }">
                            <div class="tsCell">{{data.value}}</div>
                        </template>
                    </DxDataGrid>

                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :width="120"
                              text="Speichern"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick($event)" />
                </div>
                <div>
                    <DxButton :width="120"
                              text="Löschen"
                              type="danger"
                              styling-mode="contained"
                              @click="onDeleteClick($event)" />
                </div>

                <div>
                    <DxButton :width="120"
                              text="Zurück"
                              type="back"
                              styling-mode="contained"
                              @click="onCancelClick($event)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { DxTextBox } from 'devextreme-vue/text-box'
    import { DxButton } from 'devextreme-vue/button'
    import { DxDateBox } from 'devextreme-vue/date-box'
    import { DxTabPanel, DxItem } from 'devextreme-vue/tab-panel'
    import { DxDataGrid, DxColumn, DxEditing } from 'devextreme-vue/data-grid'
    import { confirm } from "devextreme/ui/dialog"
    import notify from 'devextreme/ui/notify'
    import $ from 'jquery'

    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';


    export default {
        name: 'TopicMemberStateDetail',
        components: {
            DxButton,
            DxTextBox,
            DxDateBox,
            DxTabPanel,
            DxItem,
            DxDataGrid,
            DxColumn,
            DxEditing
        },
        data() {
            return {
                post: null,
                files: [],
                isSaving: false
            };
        },
        props: {
            tmsId: {
                type: [Number],
                required: true,
                default: 0
            },
            newTtyId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        watch: {
            topicMemberStateDetailText: function (newVal, oldVal) {
                if (oldVal != "{}" && oldVal != newVal) {
                    this.$store.state.topicMemberStateStore.topicMemberStateDetailChanged = true
                }
            },
            accessListForTopicMemberStateText: function (newVal, oldVal) {
                if (oldVal != "[]" && oldVal != newVal) {
                    this.$store.state.topicMemberStateStore.accessListForTopicMemberStateChanged = true
                }
            },
            changed: function (newVal) {
                if (!newVal && this.isSaving) {
                    this.isSaving = false
                    notify("The changes were saved successfully")
                }
            },
        },
        created: function () {
        },
        mounted: function () {
            this.$store.dispatch("getTopicMemberStateDetail", { tmsId: this.tmsId, ttyId: this.newTtyId })
            this.$store.dispatch("getAccessListForTopicMemberState", { tmsId: this.tmsId })
        },
        computed: {
            accessListForTopicMemberState() {
                return this.$store.state.topicMemberStateStore.accessListForTopicMemberState
            },
            accessListForTopicMemberStateText() {
                return JSON.stringify(this.$store.state.topicMemberStateStore.accessListForTopicMemberState)
            },
            topicMemberStateDetail() {
                return this.$store.state.topicMemberStateStore.topicMemberStateDetail
            },
            topicMemberStateDetailText() {
                return JSON.stringify(this.$store.state.topicMemberStateStore.topicMemberStateDetail)
            },
            ttyId() {
                return this.$store.state.topicMemberStateStore.topicMemberStateDetail.TtyId
            },
            saveButtonType() {
                return this.changed
                    ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.changed
                    ? false : true
            },
            changed() {
                return this.$store.state.topicMemberStateStore.topicMemberStateDetailChanged
                    || this.$store.state.topicMemberStateStore.accessListForTopicMemberStateChanged
            }
        },
        onExporting(e) {
            e.component.beginUpdate();
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Data');
            exportDataGrid({
                component: e.component,
                worksheet: worksheet
            }).then(function () {
                workbook.xlsx.writeBuffer().then(function (buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                });
            }).then(function () {
                e.component.endUpdate();
            });
        },
        methods: {
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                this.isSaving = true
                this.$store.dispatch("saveTopicMemberStateDetail")
                this.$store.dispatch("saveAccessListForTopicMemberState")
            },
            onDeleteClick() {
                let result = confirm("Sind Sie sicher, dass Sie den TopicMemberState löschen möchten? Ein Löschen ist nicht möglich, wenn bereits verknüpfte Datensätze bestehen", "Löschen bestätigen");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        var result2 = this.$store.dispatch("deleteTopicMemberState", { tmsId: this.tmsId })
                        result2.then(() => {
                            $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                        });
                    }
                });
            },
        }
    }
</script>
<style>

    div {
        text-align: left;
    }

    .options {
        margin-top: 20px;
        padding: 20px;
        background-color: rgba(191, 191, 191, 0.15);
        box-sizing: border-box;
        width: 100%;
    }

    .html-dx-field {
        width: 700px;
        height: 300px;
    }

    .html-label {
        padding-right: 200px
    }
</style>
